import React from 'react';

import { useAuthService } from '@bessemercws/auth';
import { useClientContext } from '@bessemercws/providers';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isTokenValid, removeToken } = useAuthService();
  const { isAuthing } = useClientContext();

  const hasAccess = isTokenValid(false);

  if (isAuthing) {
    return <></>;
  }

  if (!hasAccess) {
    const hadAuthenticatedSession = sessionStorage.getItem('okta-token-storage') !== null;
    if(hadAuthenticatedSession) {
      sessionStorage.setItem('sessionExpired', JSON.stringify({ expired: true, ttl: new Date().toISOString() }));
    }

    removeToken();
    return <Navigate to="/login"/>;
  }

  return children;
};
